import { TreeSelect, TreeSelectProps } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { departmentRootId, departmentsTreeAtom } from '@/modules/department'

export const DepartmentSearch: React.FC<TreeSelectProps<any>> = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation()
  const [departments] = useAtom(departmentsTreeAtom)
  const treeData = departments
    .filter((d) => d.id !== departmentRootId)
    .map((d) => ({
      id: d.id,
      pId: d.parentId,
      title: i18n.resolvedLanguage === 'zh' ? d.name : d.ename,
      value: d.id,
    }))
  return (
    <TreeSelect
      ref={ref as any}
      allowClear
      showSearch
      treeDataSimpleMode
      placeholder={t('search department')}
      treeData={treeData}
      treeNodeFilterProp='title'
      {...props}
    />
  )
})
